let regList = {
    required: true,
    mobile: /^1[3|6|4|5|7|8|9]\d{9}$/,
    mail: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
}
// 默认规则错误信息
let msgList = {
    required: '必填',
    mobile: '请输入正确的手机号',
    mail: '请输入正确的邮箱'
}
// 规则构造器
class Rules {
    constructor(rulesName, rulesValue, ruleMsg) {
        this.rulesName = rulesName
        this.rulesValue = rulesValue
        this.ruleMsg = ruleMsg
    }
}
// 表格
class VForm {
    constructor(el, finalRule) {
        this.dom = el
        this.rules = finalRule
    }
}
function createVa(vm) {
    let va = {}
    va = {
        ruleListRank: [],
        forms: {},
        checkRule(dom, rules) {
            let checkInfo = {
                required(ruleValue, vaForm, va) {
                    return vaForm.value.trim() !== ''
                },
                reg(val, vaForm, va) {
                    return regList[val].test(vaForm.value)
                }
            }
            let checkResult
            for (let item of rules) {
                let { rulesName, rulesValue, ruleMsg } = item
                if (typeof ruleValue === 'function') {
                    checkResult = rulesValue()
                } else {
                    checkResult = checkInfo[rulesName]
                        ? checkInfo[rulesName](rulesValue, dom)
                        : checkInfo.reg(rulesName, dom)
                    if (!checkResult) {
                        return {
                            checkFlag: checkResult,
                            checkMsg: ruleMsg
                        }
                    }
                }
            }
            return {checkFlag:checkResult}
        },
        checkAll() {
            let ruleListRank = this.ruleListRank
            let forms = this.forms
            let checkRule = this.checkRule
            let checkFlag = true
            let checkMsg = ''
            for (let name of ruleListRank) {
                let dom = forms[name].dom
                let rules = forms[name].rules
                let flag = checkRule(dom, rules)
                if (flag.checkFlag === false) {
                    checkFlag = flag.checkFlag
                    checkMsg = flag.checkMsg
                }
            }
            return {checkFlag:checkFlag,msg:checkMsg}
        }
    }
    if (vm.$va) {
        return vm.$va
    } else {
        vm.$va = va
        return vm.$va
    }
}
let installed = false
const Validate = {
    install(Vue, options) {
        if (installed) {
            return
        }
        Vue.directive('validate', {
            bind: function (el, binding, vnode) {
                let vm = vnode.context
                let finalRule = []
                let va = createVa(vm)
                let domSelector = binding.arg === undefined ? el.getAttribute('id') : binding.arg
                let options = binding.value ? binding.value : []
                va.ruleListRank.push(domSelector)// 表单检验的顺序
                for (let option of options) {
                    // option ---> object {'规则名':'规则','规则提示信息'}
                    if (typeof option === 'object') {
                        let rulesName = Object.keys(option)[0]
                        finalRule.push(new Rules(rulesName, option[rulesName], option.msg))
                    } else {
                        finalRule.push(new Rules(option, regList[option], msgList[option]))
                    }
                }
                va.forms[domSelector] = new VForm(el, finalRule)
            }
        })
        installed = true
    }
}
export default Validate